// extracted by mini-css-extract-plugin
export default {"newValue":"ChangeEventView_newValue__3FE8E"};